module.exports = __webpack_public_path__ + "static/media/forgejo.698c8eb0.svg";